import { PropsWithChildren } from "react"

import { Box, Button, Stack, useMediaQuery } from "@mui/material"
import theme from "@skistarab/mui-theme"

type ExpandedContentProps = {
  open: boolean
  contentId: string
  searchButtonText: string
  onToggle: () => void
  onSearch?: () => void
}

const ExpandedContent = ({
  open,
  contentId,
  searchButtonText,
  onToggle,
  onSearch,
  children,
}: PropsWithChildren<ExpandedContentProps>) => {
  const handleSearchClick = () => {
    onSearch?.()
    onToggle()
  }

  const isTablet = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <Stack
      direction={isTablet ? "row" : "column"}
      spacing={isTablet ? 1.5 : 1}
      p={isTablet ? 2 : 0}
      id={contentId}
      role="region"
      aria-labelledby={`${contentId}-label`}
      display={open ? "flex" : "none"}
    >
      <Box flexGrow={1}>{children}</Box>
      <Stack justifyContent="center">
        <Button
          size={isTablet ? "large" : "medium"}
          variant="contained"
          onClick={handleSearchClick}
          aria-label={searchButtonText}
        >
          {searchButtonText}
        </Button>
      </Stack>
    </Stack>
  )
}

export default ExpandedContent
